import type { InputOptions, Place } from './maps.types';

const CACHE = new Map<string, Place[]>();

export const cache =
    (fn: (name: string, options: InputOptions) => Promise<Place[]>, cache = CACHE) =>
    async (name: string, options: InputOptions): Promise<Place[]> => {
        const hit = cache.get(name);

        if (hit) {
            return Promise.resolve(hit);
        }

        const result = await fn(name, options);
        cache.set(name, result);
        return result;
    };
